import React from 'react';

export function useWindowEvent<K extends keyof WindowEventMap>(
  type: K,
  listener: (this: Window, ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions
) {
  React.useEffect(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, [listener, type, options]);
}

const eventListerOptions = {
  passive: true,
};

const browser = typeof window !== 'undefined';

export function useViewportSize() {
  const [windowSize, setWindowSize] = React.useState({
    width: browser ? window.innerWidth : 0,
    height: browser ? window.innerHeight : 0,
  });

  const setSize = React.useCallback(() => {
    setWindowSize({
      width: window.innerWidth || 0,
      height: window.innerHeight || 0,
    });
  }, []);

  useWindowEvent('resize', setSize, eventListerOptions);
  useWindowEvent('orientationchange', setSize, eventListerOptions);

  return windowSize;
}
